import { RootState } from '../store';

/******************** MIEMBROS **************************************/
export const selectMiembrosSlice = (state: RootState) => state.miembros;
export const selectMiembro = (state: RootState) =>
  selectMiembrosSlice(state).data.data;
export const selectMiembroLoading = (state: RootState) =>
  selectMiembrosSlice(state).loading;
export const selectMiembroPageInfo = (state: RootState) =>
  selectMiembrosSlice(state).data.meta;
/******************** CHANGE ORGANIZACIÓN MIEMBRO **************************************/

export const selectChangeOrganizacionMiembroUser = (state: RootState) =>
  state.changeOrganizacionMiembro.user;

export const selectChangeOrganizacionMiembroActive = (state: RootState) =>
  state.changeOrganizacionMiembro.active;

export const selectChangeOrganizacionMiembroLoading = (state: RootState) =>
  state.changeOrganizacionMiembro.loading;
export const selectChangeOrganizacionMiembroErrors = (state: RootState) =>
  state.changeOrganizacionMiembro.errors;

/******************** UPDATE MIEMBRO *****************************/
export const selectUpdateMiembroSlice = (state: RootState) =>
  state.updateMiembro;

export const selectUpdateMiembroErrors = (state: RootState) =>
  selectUpdateMiembroSlice(state).errors;

export const selectUpdateMiembroLoading = (state: RootState) =>
  selectUpdateMiembroSlice(state).loading;

/******************** DELETE MIEMBRO *****************************/
export const selectDeleteMiembro = (state: RootState) =>
  state.deleteMiembro.miembro;

export const selectDeleteMiembroActive = (state: RootState) =>
  state.deleteMiembro.active;

export const selectDeleteMiembroLoading = (state: RootState) =>
  state.deleteMiembro.loading;

/******************** Socio **************************************/
export const selectMiembroSocio = (state: RootState) => state.miembroSocio.data;

export const selectMiembroSocioLoading = (state: RootState) =>
  state.miembroSocio.loading;

export const selectMiembroSocioErrors = (state: RootState) =>
  state.miembroSocio.errors;

/******************** Register socio *****************************/
export const selectRegisterSocioSelectedOrganizacionId = (state: RootState) =>
  state.registerSocio.registerData?.organizacion_id;

export const selectRegisterMiembroSocioData = (state: RootState) =>
  state.registerSocio.registerData;

export const selectRegisterMiembroSocioConfirmActive = (state: RootState) =>
  state.registerSocio.confirmActive;

export const selectRegisterSocioLoading = (state: RootState) =>
  state.registerSocio.loading;

/******************** Delete socio *******************************/
export const selectDeleteMiembroSocioSocio = (state: RootState) =>
  state.deleteSocio.data;
export const selectDeleteMiembroSocioLoading = (state: RootState) =>
  state.deleteSocio.loading;
export const selectDeleteMiembroSocioConfirmActive = (state: RootState) =>
  state.deleteSocio.active;

/******************** CANCEL ASSOCIATE SUBSCRIPTION **************************************/

export const selectCancelAssociateSubscriptionUser = (state: RootState) =>
  state.cancelAssociateSubscription.user;

export const selectCancelAssociateSubscriptionActive = (state: RootState) =>
  state.cancelAssociateSubscription.active;

export const selectCancelAssociateSubscriptionLoading = (state: RootState) =>
  state.cancelAssociateSubscription.loading;
export const selectCancelAssociateSubscriptionErrors = (state: RootState) =>
  state.cancelAssociateSubscription.errors;
